import { render, staticRenderFns } from "./CustomerSearch.vue?vue&type=template&id=05d5035e&scoped=true&"
import script from "./CustomerSearch.vue?vue&type=script&lang=ts&"
export * from "./CustomerSearch.vue?vue&type=script&lang=ts&"
import style0 from "./CustomerSearch.vue?vue&type=style&index=0&id=05d5035e&prod&lang=scss&scoped=true&"
import style1 from "./CustomerSearch.vue?vue&type=style&index=1&id=05d5035e&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05d5035e",
  null
  
)

export default component.exports